<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout-icon">
        <i class="material-icons" v-on:click="cancel">arrow_back_ios</i>
      </div>          
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title"></span>
        <div class="mdl-layout-spacer"></div>
        <label v-if="visit.end_date && !visit.received_date && not_sent" class="mdl-button mdl-js-button mdl-button--icon" for="fixed-header-drawer-exp" v-on:click="save_and_send">
          <i class="material-icons">sync</i>
        </label>
      </div>
    </header>
    <main class="mdl-layout__content">
      <div class="page-content">
        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit">
          <div class="mdl-card__title2">
            {{ formatDate(visit.date) }}<br>
            <h4>{{visit.description}}</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <ul class='mdl-list'>
              <li class="mdl-list__item mdl-list__item--two-line">
                <span class="mdl-list__item-primary-content">
                  {{visit.visit_type_name}}
                  <span class="mdl-list__item-sub-title">
                    {{visit.visit_text}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.real_state_phone">
                <span class="mdl-list__item-primary-content">
                  Telefones
                  <span class="mdl-list__item-sub-title">
                    {{visit.real_state_phone}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.customer">
                <span class="mdl-list__item-primary-content">
                  {{ $t('customer') }}
                  <span class="mdl-list__item-sub-title">
                    {{visit.customer.name}}, {{visit.customer.age}} anos, {{visit.customer.sex}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.service_type">
                <span class="mdl-list__item-primary-content">
                  {{ $t('service_type') }}
                  <span class="mdl-list__item-sub-title">
                    {{visit.service_type.name}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.evaluator">
                <span class="mdl-list__item-primary-content">
                  {{ $t('evaluator') }}
                  <span class="mdl-list__item-sub-title">
                    {{visit.evaluator}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.employee_name">
                <span class="mdl-list__item-primary-content">
                  {{ $t('person') }}
                  <span class="mdl-list__item-sub-title">
                    {{visit.employee_name}} <span v-if="visit.employee_phone">{{visit.employee_phone}}</span>
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.shift_name">
                <span class="mdl-list__item-primary-content">
                  Turno
                  <span class="mdl-list__item-sub-title">
                    {{visit.shift_name}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.instructions">
                <span class="mdl-list__item-primary-content">
                  {{ $t("label.instructions") }}
                  <span class="mdl-list__item-sub-title">
                    {{visit.instructions}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.start_date">
                <span class="mdl-list__item-primary-content">
                  Iniciado em
                  <span class="mdl-list__item-sub-title">
                    {{formatHour(visit.start_date)}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.end_date">
                <span class="mdl-list__item-primary-content">
                  Finalizado em
                  <span class="mdl-list__item-sub-title">
                    {{formatHour(visit.end_date)}}
                  </span>
                </span>
              </li>              
            </ul>

            <div>

              <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored mdl-js-ripple-effect pull-left" v-on:click="checkin" v-if="visit.is_checkable == true && visit.start_date == null" :disabled="visit.start_date != null">
                {{ $t('start_visit') }}
              </button>
              <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored mdl-js-ripple-effect pull-right" v-if="visit.is_checkable == true && visit.start_date == null" :disabled="visit.start_date == null || visit.end_date != null" v-on:click="checkout">
                {{ $t('stop_visit') }}
              </button>

            </div>

          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="showNew">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Dados gerais</h4>
          </div>    
          <div class="mdl-card__supporting-text">
            <div>
              <div class='mdl-list'>
                <div>
                  <div class="mdl-list__item-primary-content">
                    <div class="checklist-title">Empresa</div>
                    <div>
                      <input type="text" class="mdl-textfield__input" v-model="visit.real_state_name" v-on:change="save(null)">
                    </div>
                  </div>
                  <div class="mdl-list__item-primary-content">
                    <div class="checklist-title">Endereço</div>
                    <div>
                      <input type="text" class="mdl-textfield__input" v-model="visit.real_state_address" v-on:change="save(null)">
                    </div>
                  </div>
                  <div class="mdl-list__item-primary-content">
                    <div class="checklist-title">Telefone</div>
                    <div>
                      <input type="text" class="mdl-textfield__input" v-model="visit.real_state_phone" v-on:change="save(null)">
                    </div>
                  </div>
                  <div class="mdl-list__item-primary-content">
                    <div class="checklist-title">Responsável</div>
                    <div>
                      <input type="text" class="mdl-textfield__input" v-model="visit.evaluator" v-on:change="save(null)">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="showChecklist" :key="visit.version">
          <div class="mdl-card__supporting-text">
            <div v-for="(section, section_index) in visit.checklist" v-bind:key="section.key">
              <h5 class="group-title" v-if="section.title">{{section.title}}</h5>
              <div v-if="section.text">{{section.text}}</div>
              <div class='mdl-list'>
                <div v-for="(item, item_index) in section.items"  v-bind:key="item.key">
                  <hr>
                  <div class="mdl-list__item-primary-content">
                    <div class="comments-button">
                      <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab" v-on:click="showMessageDialog(section_index, item_index)" v-if="item.is_commentable == true && visit.end_date == null">
                        <i class="material-icons">comment</i>
                      </button>
                      <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab" v-on:click="takePicture(section_index, item_index)" v-if="item.is_picturable == true && visit.end_date == null">
                        <i class="material-icons">camera_alt</i>
                      </button>
                    </div>
                    <div class="checklist-title">{{item.title}}</div>
                    <div v-if="item.type == 'boolean'">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, true)" v-html="radioIcon(section_index, item_index, true)"></i> {{ item['yes_label'] || 'Sim'}}
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, false)" v-html="radioIcon(section_index, item_index, false)"></i> {{ item['no_label'] || 'Não'}}
                      <span v-if="item.na == true">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, 'n/a')" v-html="radioIcon(section_index, item_index, 'n/a')" ></i> {{item.na_label || 'N/A' }}
                      </span>
                    </div>
                    <div v-if="item.type == 'na'">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, true)" v-html="radioIcon(section_index, item_index, true)"></i> {{ item['yes_label'] || 'Sim'}}
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, false)" v-html="radioIcon(section_index, item_index, false)"></i> {{ item['no_label'] || 'Não'}}
                      <span v-if="item.na == true">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, 'n/a')" v-html="radioIcon(section_index, item_index, 'n/a')" ></i> {{item.na_label || 'N/A' }}
                      </span>
                    </div>
                    <div v-if="item.type == 'date'">
                      <input type="date" v-bind:id="section_index + '_' + item_index" class="mdl-textfield__input" v-bind:value="item.value" v-on:change="dateSet(section_index, item_index)" :disabled="readOnly()">
                    </div>
                    <div v-if="item.type == 'point'">
                      <i class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, '0')" v-html="radioIcon(section_index, item_index, '0')"></i> 0
                      <i class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, '1')" v-html="radioIcon(section_index, item_index, '1')"></i> 1
                      <span v-if="item.weight >= 2">
                      <i class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, '2')" v-html="radioIcon(section_index, item_index, '2')"></i> 2
                      </span>
                      <span v-if="item.weight >= 3">
                      <i class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, '3')" v-html="radioIcon(section_index, item_index, '3')"></i> 3
                      </span>
                      <span v-if="item.weight >= 4">
                      <i class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, '4')" v-html="radioIcon(section_index, item_index, '4')"></i> 4
                      </span>
                      <span v-if="item.weight >= 5">
                      <i class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, '5')" v-html="radioIcon(section_index, item_index, '5')"></i> 5
                      </span>
                      <span v-if="item.na == true">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, 'n/a')" v-html="radioIcon(section_index, item_index, 'n/a')" ></i> {{item.na_label || 'N/A' }}
                      </span>
                    </div>
                    <div v-if="item.type == 'options'">
                      <span v-for="(option, option_index) in item.options" :key="option_index">
                        <i  class="material-icons checklist-option" v-on:click="radioSet(section_index, item_index, option)" v-html="radioIcon(section_index, item_index, option)"></i>
                          {{option}}
                      </span>
                      <span v-if="item.na == true">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, 'n/a')" v-html="radioIcon(section_index, item_index, 'n/a')" ></i> {{item.na_label || 'N/A' }}
                      </span>
                    </div>
                    <div v-if="item.type == 'multi-options'">
                      <span v-for="(option, option_index) in item.options" :key="option_index">
                        <i class="material-icons checklist-option" v-on:click="checkSet(section_index, item_index, option)" v-html="checkIcon(section_index, item_index, option)"></i>
                          {{option}}
                      </span>
                    </div>
                    <div v-if="item.type == 'text'">
                      <textarea class="mdl-textfield__input" v-bind:id="section_index + '_' + item_index" rows= "10" v-bind:value="item.value" v-on:change="textSet(section_index, item_index)" :disabled="readOnly()"></textarea>
                    </div>
                    <div v-if="item.type == 'string'">
                      <input type="text" v-bind:id="section_index + '_' + item_index" class="mdl-textfield__input" v-bind:value="item.value" v-on:change="textSet(section_index, item_index)" :disabled="readOnly()">
                    </div>
                    <div v-if="item.type == 'integer'">
                      <input type="number" v-bind:id="section_index + '_' + item_index" class="mdl-textfield__input" v-bind:value="item.value" v-on:change="textSet(section_index, item_index)" :disabled="readOnly()">
                    </div>
                    <div v-if="item.type == 'table'">
                      <table class="mdl-data-table mdl-js-data-table" width="100%">
                        <thead>
                          <tr>
                            <th v-for="(column, column_index) in item.columns" :key="column_index" class="mdl-data-table__cell--non-numeric">
                              {{column}}
                            </th>
                            <th v-if="!readOnly()"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, row_index) in (item.value || [''])" :key="row_index">
                            <td v-for="(column, column_index) in item.columns" :key="column_index">
                              <input type="text" v-bind:id="section_index + '_' + item_index + '_' + row_index + '_' + column_index" class="mdl-textfield__input" v-bind:value="getCell(section_index, item_index, row_index, column_index)" v-on:change="changeCell(section_index, item_index, row_index, column_index)" :disabled="readOnly()">
                            </td>
                            <td v-if="!readOnly()"><button class="mdl-button mdl-js-button mdl-button--icon"><i class="material-icons" v-on:click="deleteRow(section_index, item_index, row_index)">delete</i></button></td>
                          </tr>
                          <tr v-if="!readOnly()">
                            <td v-bind:colspan="item.columns.length + 1">
                              <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" v-on:click="addRow(section_index, item_index)">
                                <i class="material-icons">add</i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-if="item.type == 'integers'">
                      <table class="mdl-data-table mdl-js-data-table" width="100%">
                        <tbody>
                          <tr v-for="row_index in 1" :key="row_index">
                            <td v-for="column_index in item.quantity" :key="column_index">
                              <input type="number" v-bind:id="section_index + '_' + item_index + '_' + row_index + '_' + column_index" class="mdl-textfield__input" v-bind:value="getCell(section_index, item_index, row_index, column_index)" v-on:change="changeCell(section_index, item_index, row_index, column_index)" :disabled="readOnly()" v-bind:placeholder="'Medida ' + column_index">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span v-if="item.na == true">
                      <i class="material-icons" v-on:click="radioSet(section_index, item_index, 'n/a')" v-html="radioIcon(section_index, item_index, 'n/a')" ></i> {{item.na_label || 'N/A' }}
                      </span>                      
                    </div>
                    <div v-if="item.comments" class="item-comments">
                      <i>{{item.comments}}</i>
                    </div>
                    <img v-bind:src="picture.resized" v-for="picture in pictures" v-if="picture.item_key == section_index + '_' + item_index" v-bind:key="picture.uuid" class="picture">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="showPictures">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Fotos</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <button class="mdl-button mdl-js-button mdl-button--colored mdl-button--raised mdl-js-ripple-effect" v-on:click="takePicture(null, null)" v-if="visit.end_date == null"><i class="material-icons">camera_alt</i></button>
            <br>
            <input type="file" id="picture"  accept="image/*" capture="camera" class="hidden" v-on:change="savePicture()">
            <img v-bind:src="picture.resized" v-for="picture in pictures" v-bind:key="picture.uuid" class="picture" v-if="picture.item_key == null">
            <div id="well"></div>
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="showRating">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Avaliação</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <div v-if="visit.status == 'open'">
              Está satisfeito com nossos serviços?<br><br>
            </div>
            <i class="material-icons rating_star" v-on:click="selectStar(1)">{{ starIcon(visit, 1) }}</i><i class="material-icons rating_star" v-on:click="selectStar(2)">{{ starIcon(visit, 2) }}</i><i class="material-icons rating_star" v-on:click="selectStar(3)">{{ starIcon(visit, 3) }}</i><i class="material-icons rating_star" v-on:click="selectStar(4)">{{ starIcon(visit, 4) }}</i><i class="material-icons rating_star" v-on:click="selectStar(5)">{{ starIcon(visit, 5) }}</i>
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="showComments">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Comentários</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <textarea class="mdl-textfield__input" type="text" rows= "10" placeholder="" v-model="visit.comments" v-on:change="save" :disabled='visit.end_date != null'></textarea>
          </div>
        </div>

        <div id="panel-signature" class="mdl-card mdl-cell mdl-cell--12-col">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Assinatura</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <div id="signature"></div>
            <canvas id="canvas"></canvas>
            <button v-on:click="clearSignature" v-if="visit.status != 'closed'">Corrigir</button>
            <br>
            Assinado por
            <input type="text" v-model="visit.evaluator">
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit.status != 'open'">
          <div class="mdl-card__supporting-text">
            <br>
            Confira todas as informações antes de Finalizar Visita.
            <br>
            <br>
            <div>
              <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored mdl-js-ripple-effect pull-left" v-on:click="checkin" v-if="visit.is_checkable == true && visit.start_date != null" :disabled="visit.start_date != null">
                {{ $t('start_visit') }}
              </button>
              <button class="mdl-button mdl-js-button mdl-button--colored mdl-button--raised mdl-js-ripple-effect pull-right" v-on:click="pre_checkout" v-if="visit.is_checkable == true && visit.start_date != null" :disabled="visit.end_date != null">
                {{ $t('stop_visit') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <dialog id="comment-dialog" class="mdl-dialog">
      <div class="mdl-dialog__content">
        <input type="hidden" id="section-key">
        <input type="hidden" id="item-key">
        <textarea class="mdl-textfield__input" id="message-box" rows="5"></textarea>
      </div>
      <div class="mdl-dialog__actions">
        <button id="btn-save-message" type="button" class="mdl-button mdl-button--raised mdl-button--colored" v-on:click="saveMessage()">Salvar</button>
        <button id="btn-close-message" type="button" class="mdl-button mdl-button--raised close" v-on:click="closeMessageDialog()">Cancelar</button>
      </div>
    </dialog>
    <dialog id="spinner-dialog" class="mdl-dialog">
      <div class="mdl-dialog__content">
        <div class="collapse">
            <div class="loader"></div>
        </div>
      </div>
    </dialog>
  </div>
</template>
<script>

  import Vue from 'vue'
  import firebase from 'firebase/app'
  import db from './firebaseInit'
  import * as moment from 'moment'
  import localDb from './localDb'
  import SignaturePad from 'signature_pad'
  import Compressor from 'compressorjs'
  import dialogPolyfill from 'dialog-polyfill'

  import 'material-design-lite'

  if(/Android 4\.[0-3]/.test(navigator.appVersion)){
     window.addEventListener("resize", function(){
        if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA"){
           window.setTimeout(function(){
              document.activeElement.scrollIntoViewIfNeeded();
           },0);
        }
     })
  }

  var instancePath = 'instances/' + process.env.FSM_ENV
  var requestsRef = db.collection(instancePath + '/requests')

  export default {
    data: function() {
      return {
        id: null,
        demo: process.env.FSM_DEMO,
        visit: {
        },
        signaturePad: null,
        item_key: null,
        pictures: [],
        not_sent: true
      }  
    },
    mounted() {
      var data = this

      var id = this.$route.params.id

      if (id == 'new') {
        let base = {
          id: 'new',
          customer_name: '',
          date: moment().toISOString(),
          description: '',
          employee_name: '',
          employee_phone: '',
          evaluator: '',
          instructions: '',
          is_checkable: true,
          is_rateable: true,
          is_signable: true,
          is_simple: false,
          real_state_address: '',
          real_state_name: '',
          real_state_phone: '',
          status: 'open',
          visit_type_icon: "<i class='material-icons'>redeem</i>",
          visit_type_name: "Visita avulsa",
          comments: '', 
          rating: 0, 
          start_date: null,
          version: 0
        }
        data.visit = base
      } else {
        data.id = id
        localDb.visits.where({id: id}).first().then(function(visit) {
          let base = { comments: '', rating: 0, start_date: null }
          Object.assign(base, visit);
          data.visit = base
          data.operatorRef().collection('visits').doc(data.id).collection('pictures').get().then(function(query) {
              query.forEach(function(doc) {
                data.pictures.push(doc.data())
              })
          })
          if (!data.visit.is_signable || data.visit.start_date == null) {
            if (document.getElementById('panel-signature') != null) {
              document.getElementById('panel-signature').classList.add('hidden')
            }
          } else {
            if (visit.status == 'closed') {
              var img = new Image();
              img.src = data.visit.signature
              img.style.width = "100%"
              var canvas = document.getElementById('canvas')
              canvas.classList.add('hidden')
              document.getElementById('signature').appendChild(img)
            } else {
              if (data.signaturePad == null) {
                var canvas = document.getElementById('canvas')
                if (canvas != null) {
                  var signaturePad = new SignaturePad(canvas)
                  data.signaturePad = signaturePad
                  var ratio =  Math.max(window.devicePixelRatio || 1, 1);
                  var canvas = document.getElementById('canvas')
                  if (canvas != null) {
                    canvas.width = canvas.offsetWidth * ratio;
                    canvas.height = canvas.offsetHeight * ratio;
                    canvas.getContext("2d").scale(ratio, ratio);
                    signaturePad.clear(); // otherwise isEmpty() might return incorrect value
                  }  
                }
              }
            }
          }
        })        
      }
      dialogPolyfill.registerDialog(document.getElementById("comment-dialog"))
      dialogPolyfill.registerDialog(document.getElementById("spinner-dialog"))
      componentHandler.upgradeAllRegistered()
    },
    methods: {
      formatDate: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY')
      },
      formatHour: function(date) {
        return moment(date).format('HH:mm')
      },
      save: function(callback) {
        let data = this
        data.visit.version += 1
        db.doc(instancePath + '/people/' + this.currentUser()).collection('visits').doc(data.id).update(data.visit).then(function() {
          if (callback != null) callback()
        })
      },
      send: function() {
        console.log('sent')
        this.not_sent = false
        requestsRef.add({
          key: this.id,
          visit: this.visit
        })
      },
      save_and_send: function() {
        this.save(this.send)
      },
      checkin: function() {
        //document.getElementById('spinner-dialog').showModal();
        var data = this;
        this.visit.start_date = moment().toISOString();
        this.visit.status = 'started'
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(
            function(position) {
              data.visit.start_coords = position.coords.latitude + ',' + position.coords.longitude;
              data.save(data.after_checkin)
            },
            function(error) {
              data.visit.start_coords = "Indisponivel (codigo " + error.code + ")";
              data.save(data.after_checkin)
            }
          );
        } else {
          this.save(data.after_checkin)
        }
      },
      pre_checkout: function() {
        document.getElementById('spinner-dialog').showModal();
        var data = this;
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(
            function(position) {
              data.visit.end_coords = position.coords.latitude + ',' + position.coords.longitude;
              data.checkout()
            },
            function(error) {
              data.visit.end_coords = "Indisponivel (codigo " + error.code + ")";
              data.checkout()
            }
          );
        } else {
          data.checkout()
        }
      },
      checkout: function() {
        console.log('checkout')
        let data = this
        this.visit.status = 'closed'
        if (this.visit.is_signable) {
          if (this.signaturePad)
            this.visit.signature = this.signaturePad.toDataURL("image/jpg")
        }
        this.visit.end_date = moment().toISOString();
        this.visit.sent = false
        this.save_and_send()
        this.$router.push('/calendar')
      },
      after_checkin: function() {
        var data = this;
        requestsRef.add({
          key: this.$route.params.id,
          visit: this.visit
        })
        //document.getElementById('spinner').showModal();
        //window.setTimeout(function(){
          //this.$router.push("/visits/" + this.$route.params.id + "/?r=1");
        this.visit.version = 1;
        //},500);
        this.$router.push("/refresh/" + this.id)
      },
      radioIcon: function(section_key, item_key, value) {
        return ('value' in this.visit.checklist[section_key].items[item_key] && this.visit.checklist[section_key].items[item_key].value == value) ? 'radio_button_checked' : 'radio_button_unchecked'
        this.save(null)
      },
      checkIcon: function(section_key, item_key, value) {
        return ('value' in this.visit.checklist[section_key].items[item_key] && this.visit.checklist[section_key].items[item_key].value.indexOf(value) >= 0) ? 'check_box' : 'check_box_outline_blank'
        this.save(null)
      },
      starIcon: function(visit, level) {
        if (visit.rating >= level) {
          return 'star'
        } else {
          return 'star_border'
        }
      },
      selectStar: function(level) {
        if (this.visit.status != 'closed')
          this.visit.rating = level
      },
      radioSet: function(section_key, item_key, value) {
        if (!this.readOnly()) {
          var section = this.visit.checklist[section_key]
          section.items[item_key].value = value
          Vue.set(this.visit.checklist, section_key, null)
          Vue.set(this.visit.checklist, section_key, section)
          this.save(null)
        }
      },
      checkSet: function(section_key, item_key, value) {
        if (!this.readOnly()) {
          var section = this.visit.checklist[section_key]
          let array = section.items[item_key].value
          if (array == null) {
            array = []
          }
          var index = array.indexOf(value)
          if (index < 0) {
            array.push(value)
          } else {
            array.splice(index, 1)
          }
          section.items[item_key].value = array
          Vue.set(this.visit.checklist, section_key, null)
          Vue.set(this.visit.checklist, section_key, section)
          this.save(null)
        }
      },
      dateSet: function(section_key, item_key) {
        var section = this.visit.checklist[section_key]
        section.items[item_key].value = document.getElementById(section_key + '_' + item_key).value
        Vue.set(this.visit.checklist, section_key, null)
        Vue.set(this.visit.checklist, section_key, section)
        this.save(null)
      },
      textSet: function(section_key, item_key) {
        var section = this.visit.checklist[section_key]
        section.items[item_key].value = document.getElementById(section_key + '_' + item_key).value
        Vue.set(this.visit.checklist, section_key, null)
        Vue.set(this.visit.checklist, section_key, section)
        this.save(null)
      },
      getCell(section_key, item_key, row_index, column_index) {
        var section = this.visit.checklist[section_key]
        let array = section.items[item_key].value
        if (array == null) {
          return ''
        }
        let value = JSON.parse(array[row_index])[column_index]
        return value
      },
      changeCell(section_key, item_key, row_index, column_index) {
        var section = this.visit.checklist[section_key]
        let array = section.items[item_key].value
        if (array == null) {
          array = ["[]", "[]"]
        }
        let row = JSON.parse(array[row_index])
        row[column_index] = document.getElementById(section_key + '_' + item_key + '_' + + row_index + "_" + column_index).value
        array[row_index] = JSON.stringify(row)
        section.items[item_key].value = array
        Vue.set(this.visit.checklist, section_key, null)
        Vue.set(this.visit.checklist, section_key, section)
        this.save(null)
      },
      addRow: function(section_key, item_key) {
        var section = this.visit.checklist[section_key]
        let array = section.items[item_key].value
        if (array == null) {
          array = ["[]"]
        }
        array.push("[]")
        section.items[item_key].value = array
        Vue.set(this.visit.checklist, section_key, null)
        Vue.set(this.visit.checklist, section_key, section)
      },
      deleteRow: function(section_key, item_key, row_index) {
        var section = this.visit.checklist[section_key]
        let array = section.items[item_key].value
        if (array == null) {
          array = ["[]"]
        }
        array.splice(row_index, 1)
        section.items[item_key].value = array
        Vue.set(this.visit.checklist, section_key, null)
        Vue.set(this.visit.checklist, section_key, section)
      },
      cancel: function() {
        this.$router.push('/calendar')
      },
      back: function() {
        this.$router.go(-1)
      },
      clearSignature: function() {
        this.signaturePad.clear()
      },
      readOnly: function() {
        return this.visit.end_date != null
      },
      takePicture: function(section_index, item_index) {
        if (section_index != null) {
          this.item_key = section_index + '_' + item_index
        } else {
          this.item_key = null;
        }
        document.getElementById('picture').click();
      },
      savePicture: function() {
        var data = this;
        var file = document.getElementById('picture').files[0];
        new Compressor(file, {
          quality: 0.8,
          width: 320,
          success: function(result) {
            var img = new Image()
            img.onload = function() {
              var canvas = document.createElement('canvas')
              canvas.width = img.naturalWidth
              canvas.height = img.naturalHeight
              canvas.getContext('2d').drawImage(img, 0, 0)
              let picture = {uuid: data.uuidv4(), resized: canvas.toDataURL('image/jpeg') }
              if (data.item_key != null) {
                picture['item_key'] = data.item_key;
              }
              data.pictures.push(picture)
              data.operatorRef().collection('visits').doc(data.id).collection('pictures').doc(picture['uuid']).set(picture).then(function() {
                console.log("Document successfully written!");
              })
              .catch(function(error) {
                console.error("Error writing document: ", error);
              });
            }
            img.src = window.URL.createObjectURL(result)
          }
        })
      },
      showMessageDialog: function(section_key, item_key) {
        document.getElementById("section-key").value = section_key
        document.getElementById("item-key").value = item_key
        var section = this.visit.checklist[section_key]
        if (typeof section.items[item_key].comments != 'undefined')
          document.getElementById("message-box").value = section.items[item_key].comments
        else
          document.getElementById("message-box").value = ''
        document.getElementById('comment-dialog').showModal()
      },
      closeMessageDialog: function() {
        document.getElementById('comment-dialog').close()
      },
      saveMessage: function() {
        var section_key = document.getElementById("section-key").value
        var item_key = document.getElementById("item-key").value
        var section = this.visit.checklist[section_key]
        section.items[item_key].comments = document.getElementById("message-box").value
        Vue.set(this.visit.checklist, section_key, null)
        Vue.set(this.visit.checklist, section_key, section)
        this.save(null)
        document.getElementById('comment-dialog').close()
      },
      uuidv4: function()  {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
      },
      currentUser: function() {
        return localStorage.getItem('currentUser');
      },
      operatorRef: function() {
        return db.doc('instances/' + process.env.FSM_ENV + '/people/' + this.currentUser());
      }
    },
    computed: {
      showNew: function() {
        return this.visit.id == 'new' && this.visit.start_date != null
      },
      showSignature: function() {
        return this.visit.is_signable == true && this.visit.start_date != null
      },
      showPictures: function() {
        return this.visit.is_picturable == true && this.visit.start_date != null
      },
      showRating: function() {
        return this.visit.is_rateable == true && this.visit.start_date != null
      },
      showChecklist: function() {
        return Array.isArray(this.visit.checklist) && this.visit.start_date != null
      },
      showComments: function() {
        return this.visit.is_checkable == true && this.visit.start_date != null
      },
      showCheckout: function() {
        return this.visit.is_checkable == true && this.visit.start_date != null
      }
    }
  }
</script>
<style scoped>
ul {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
}
li {
  margin: 4px 0;
  display: list-item;
  text-align: -webkit-match-parent;
}
.mdl-list__item {
  padding: 0px;
}
.mdl-card__supporting-text {
  padding-top: 0px;
}
.mdl-list__item--two-line {
  height: 56px;
}
.rating_star {
  font-size: 48px;
}
.mdl-card__title2 {
  padding: 16px;
}
h4 {
  margin-top: 0px;
}
.group-title {
  margin-top: 15px;
}
h5 {
  margin-bottom: 5px;
}
textarea {
  border: 1px solid grey;
}
.checklist-title {
  margin-bottom: 10px;
}
canvas {
  width: 100%;
  min-height: 200px;
  border: 1px solid grey;
}
.picture {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  margin: 2px;
  width: 96px;
}
.item-comments {
  margin-top: 5px;
  padding: 5px;
  background-color: #f8f2c6;
  border-radius: 5px;
  box-shadow: 0 1px 0.5px rgba(0,0,0,.13);
}
.comments-button {
  float:right;
}
</style>


// WEBPACK FOOTER //
// src/components/VisitView.vue